import { onMounted, ref, inject } from "vue"
import useApp from "@/composables/useApp"
import router from "@/router/index"
import axios from "@/axios"
import { useStore } from 'vuex'

const useMonitorUsers = () => {

    const swal = inject("$swal")
    const store = useStore();
    const { ToastMsg, ToastMsgError, ToastMsgInfo, ToastMsgWarning, validEmail } = useApp();

    const data = ref({
        users_data: [],
        new_account: {
            email: "",
            link: "",
          }
    })

    onMounted(()=>{
        if (store.state.auth.userData.role == "monitor") {
            router.push("/dashboard");
          }
        getUsers();
    })

    const getUsers = async () => {
        const axiosHeaders = {
          headers: {
            token: store.state.auth.token,
          },
        };
  
        try {
          const res = await axios.get("/monitor-user", axiosHeaders);
          data.value.users_data = res.data.users;
        } catch (error) {
          ToastMsgInfo("Error solicitando Usuarios", "user", 5000);
          console.log(error);
          return;
        }
      }

      const copyClipboard = () => {
        try {
          navigator.clipboard.writeText(data.value.new_account.link)
          .then(() => {
            ToastMsgWarning("Copiado al Portapapeles", "server", 5000);
          });
        } catch (err) {
          ToastMsgError("Error al Copiar", "server", 5000);
        }
      }

      const updateUserStatus = async ({_id, is_active}) => {
        const axiosHeaders = {
          headers: {
            token: store.state.auth.token,
          },
        };
        const body = {
          user_id: _id,
          status: is_active,
        };
  
        try {
          const res = await axios.put("/monitor-user", body, axiosHeaders);
  
          if (res.data.status == "success") {
            ToastMsgInfo("Usuario Actualizado", "user", 5000);
          }
          getUsers();
        } catch (error) {
          ToastMsgError("Error al actulizar Usuario", "user", 5000);
          console.log(error);
        }
      }

      const createEmailRegistration = async ()=> {
        if (!validEmail(data.value.new_account.email)) {
          alert("Correo electronico No Valido !");
          return;
        }
        data.value.new_account.email = data.value.new_account.email.toLowerCase();
        data.value.new_account.link =
          location.protocol + "//" + location.host + "/register?token=";
  
        const axiosHeaders = {
          headers: {
            token: store.state.auth.token,
          },
        };
  
        const toSend = {
          email: data.value.new_account.email,
          link:  data.value.new_account.link,
          linkedClient: store.state.auth.userData._id,
        };
  
        axios
          .post("/monitor-user", toSend, axiosHeaders)
          .then((res) => {
            if (res.data.status == "success") {
              const token = res.data.token;
              ToastMsgInfo("Token Registrado Correctamente", "user", 5000);
              data.value.new_account.link +=
                encodeURIComponent(token) +
                "&email=" +
                encodeURIComponent(res.data.email);
              return;
            }
          })
          .catch((err) => {
            ToastMsgError(err.response.data.error, "user", 5000);
            return;
          });
      }

      const showAlertConfirm = (title, text, icon, funct, row) => {
        swal({
          title: title,
          text: text,
          icon: icon,
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            if (funct == "delete") {
                deleteMonitorUser(row)
            } else {
                updateUserStatus(row);
            }
          } else if (funct != "delete") {
            row.is_active = !row.is_active
          }
        });
      };

      const deleteMonitorUser = async ( { _id } ) => {
        try{
        const axiosHeaders = {
            headers: {
              token: store.state.auth.token,
            },
            params: { id: _id }
          }; 
          
          const resp = await axios.delete("monitor-user",axiosHeaders);
          if (resp.data.status == "success"){
            ToastMsgWarning("Usuario Monitor Borrado Correctamente","user", 5000)
          }
          getUsers();
        }
        catch (err) {
            ToastMsgError("Error de Solicitud !", "cloud", 5000 )
            console.log(err);
        }
      }

return {
    data,
    getUsers,
    updateUserStatus,
    createEmailRegistration,
    copyClipboard,
    deleteMonitorUser,
    showAlertConfirm
    }
}

export default useMonitorUsers